import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import {
  FaCloud,
  FaCogs,
  FaBuilding,
  FaTools,
  FaNetworkWired,
  FaServer,
  FaLightbulb,
} from "react-icons/fa";

const servicesVideo = "https://rapid-lab-7fb3.tiwarikush9328.workers.dev/services_new.mp4";

const items = [
  { title: "Public & Cloud Offerings", desc: "Tailored solutions and integrations for PCO partners.", icon: <FaCogs className="text-red-600" />, link: "/all-services#public-and-cloud-offerings" },
  { title: "AI Management Platform", desc: "Optimize cloud costs and operations.", icon: <FaCloud className="text-red-600" />, link: "/all-services#cloud-ai" },
  { title: "Modern Data Center Infrastructure", desc: "High-performance, scalable, and secure DC designs.", icon: <FaBuilding className="text-red-600" />, link: "/all-services#data-center" },
  { title: "AMC (Annual Maintenance Contracts)", desc: "Proactive maintenance and reliable support.", icon: <FaTools className="text-red-600" />, link: "/all-services#amc" },
  { title: "Structured Cabling Solutions", desc: "Organized, reliable connectivity with easy scalability.", icon: <FaNetworkWired className="text-red-600" />, link: "/all-services#cabling" },
  { title: "Servers / Storage", desc: "From desktops to servers—network-ready resources.", icon: <FaServer className="text-red-600" />, link: "/all-services#servers" },
  { title: "Cyber Security", desc: "Use technology effectively to achieve growth.", icon: <FaLightbulb className="text-red-600" />, link: "/all-services#cyber-security" },
  { title: "IT Products", desc: "Quality IT hardware and accessories for modern teams.", icon: <FaServer className="text-red-600" />, link: "/all-services#it-products" },
  { title: "Indematics", desc: "Right solutions for the right challenges, delivered with expertise.", icon: <FaServer className="text-red-600" />, link: "/all-services#indematics" },
];

export default function ServicesPage() {
  return (
    <div className="font-poppins">
      <section
        id="services"
        className="relative pt-28 pb-24 px-6 sm:px-8 font-[Poppins] overflow-hidden scroll-mt-24"
      >
        {/* Background video */}
        <video
          className="absolute inset-0 w-full h-full object-cover -z-10"
          autoPlay
          loop
          muted
          playsInline
        >
          <source src={servicesVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        {/* Section heading */}
        <div className="text-center mb-12 relative z-10">
          <h2 className="text-3xl font-bold text-black mb-4">Our Services</h2>
          <p className="text-lg text-gray-800 max-w-2xl mx-auto">
            Innovative, reliable, and future-ready solutions for modern businesses.
          </p>
        </div>

        {/* Grid of services */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto relative z-10">
          {items.map((item, index) => (
            <Link key={index} to={item.link}>
              <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="bg-white/90 backdrop-blur p-4 sm:p-6 rounded-2xl shadow-lg shadow-black/20 hover:-translate-y-1 hover:shadow-2xl transition transform duration-300 text-center cursor-pointer h-full flex flex-col gap-3 border border-white/40"
              >
                <div className="flex justify-center">
                  <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-red-50 border border-red-200 flex items-center justify-center">
                    {item.icon}
                  </div>
                </div>
                <h3 className="text-base sm:text-lg lg:text-xl font-semibold text-gray-900 break-words">
                  {item.title}
                </h3>
                <p className="text-gray-700 text-sm sm:text-base break-words flex-1">{item.desc}</p>
                <span className="text-sm font-semibold text-red-600">Learn more →</span>
              </motion.div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
